"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var useIpLocation = function useIpLocation(onError, onSuccess) {
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _ipApiRes$data, _countryCodeApiRes$da, _countryList$find, ipApiRes, country, countryCodeApiRes, countryList, _ipApiRes$data2, countryCode, isNonUk, dialingCode;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios.default.get("https://pro.ip-api.com/json/?key=".concat(process.env.REACT_APP_IP_API_KEY));

            case 3:
              ipApiRes = _context.sent;
              country = ipApiRes === null || ipApiRes === void 0 ? void 0 : (_ipApiRes$data = ipApiRes.data) === null || _ipApiRes$data === void 0 ? void 0 : _ipApiRes$data.country;
              _context.next = 7;
              return _axios.default.get("/countries-phone-codes");

            case 7:
              countryCodeApiRes = _context.sent;
              countryList = countryCodeApiRes === null || countryCodeApiRes === void 0 ? void 0 : (_countryCodeApiRes$da = countryCodeApiRes.data) === null || _countryCodeApiRes$da === void 0 ? void 0 : _countryCodeApiRes$da.data;
              _ipApiRes$data2 = ipApiRes === null || ipApiRes === void 0 ? void 0 : ipApiRes.data, countryCode = _ipApiRes$data2.countryCode;
              isNonUk = country.indexOf("United Kingdom") < 0;
              dialingCode = (_countryList$find = countryList.find(function (obj) {
                return obj.code === countryCode;
              })) === null || _countryList$find === void 0 ? void 0 : _countryList$find.callingCode;

              if (onSuccess) {
                onSuccess({
                  country: country,
                  dialingCode: dialingCode,
                  isNonUk: isNonUk
                });
              }

              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);

              if (onError) {
                onError(_context.t0);
              }

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15]]);
    }))();
  }, []);
  return [];
};

var _default = useIpLocation;
exports.default = _default;